<script>
export default {
  components: {},
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    autoSelectDefault: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      options: []
    };
  },
  computed: {
    selectedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  mounted() {
    this.initOptions();
  },
  methods: {
    initOptions() {
      this.loading = true;
      this.$store.dispatch('bu_currency/fetchOptions', {
        page: 1,
        size: 99
      }).then(res => {
        this.options = res.data.records;

        // 自动选中默认的币种
        if (!this.value && this.autoSelectDefault) {
          const defaultCurrency = this.options.find(item => item.defaultFlag)
          if (defaultCurrency) {
            this.selectedValue = defaultCurrency.currencyCode;
          }
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    onChange(val) {
      this.$emit('change', this.options.find(item => item.currencyCode === val))
    }
  }
}
</script>

<template>
  <el-select
    v-model="selectedValue"
    :loading="loading"
    v-bind="$attrs"
    @change="onChange"
    filterable
    default-first-option
    clearable
  >
    <el-option
      v-for="item in options"
      :key="item.currencyCode"
      :label="item.currencyCode"
      :value="item.currencyCode"
    >
      <span style="float: left">{{ item.currencyCode }}</span>
      <span style="float: right">{{ item.currencyName }}</span>
    </el-option>
  </el-select>
</template>

<style lang="scss" scoped></style>